import { render, staticRenderFns } from "./clipboard-input.vue?vue&type=template&id=c74d8836&scoped=true&"
import script from "./clipboard-input.vue?vue&type=script&lang=js&"
export * from "./clipboard-input.vue?vue&type=script&lang=js&"
import style0 from "./clipboard-input.vue?vue&type=style&index=0&id=c74d8836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74d8836",
  null
  
)

export default component.exports